import React from 'react';

import { twMerge } from 'tailwind-merge';

import Typography from 'components/typography/typography';

import Icon from 'components/icon/icon';

import type { IconTypes } from 'components/icon';
import { createLocale } from 'locales';

const localize = createLocale('freelancerFillInformationPageLocales');

type StepCardProps = {
  icon: IconTypes;
  title: string;
  onClick: () => void;
  status: 'completed' | 'not-completed' | undefined;
  className?: string;
};

const StepCard = (props: StepCardProps): JSX.Element => {
  const { icon, title, status, onClick, className } = props;

  const cardClassName = twMerge(
    'flex flex-row items-center justify-start',
    'h-16 bg-background w-full border border-gray100',
    'py-3 px-4 mt-10 rounded-lg shadow-10',
    className,
  );
  const statusClassName = twMerge(
    'mt-1 text-current',
    status === 'completed' &&
      'text-[#1E928F] flex flex-row items-center justify-start',
    status !== 'completed' && 'text-gray500',
  );
  const statusTitle =
    status === 'completed'
      ? localize('stepCompleted')
      : localize('stepNonCompleted');

  return (
    <button type="button" onClick={onClick} className={cardClassName}>
      <Icon icon={icon} size={28} className="mr-5 text-purple" />
      <div className="flex flex-col w-full items-start justify-center">
        <Typography as="h4" variant="body-medium-bold" className="text-gray600">
          {title}
        </Typography>
        <Typography as="h4" variant="body-small" className={statusClassName}>
          {status === 'completed' && (
            <Icon icon="circle-checked" size={16} className="mr-1" />
          )}
          {statusTitle}
        </Typography>
      </div>
    </button>
  );
};

export default StepCard;
